<template>
  <div class="index" :style="{ paddingTop: statusBar + 'rem' }">
    <Header :title="topicName" :back="true" left="首页" :white="true" />
    <div style="margin: 0 auto">
      <img src="@/views/image/kxc.png" alt />
    </div>
    <van-form @submit="onSubmit">
      <van-field v-model="certName" name="用户名" label="用户名" placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field v-model="certNo" name="身份证号" label="身份证号" placeholder="身份证号" :rules="[{ required: true, message: '请填写密码' }]" />

      <div style="margin: 16px">
        <van-button :disabled="disabled" type="primary" size="large" @click="fromSubmit()">提交</van-button>
      </div>
    </van-form>
    <div style="width: 360px">
      <p style="
          font-size: 20px;
          color: green;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        ">
        用户名：{{ ResultcertName }}
      </p>
      <p style="
          font-size: 20px;
          color: green;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        ">
        身份证号：{{ ResultCertNo }}
      </p>
      <p style="
          font-size: 20px;
          color: green;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        ">
        业务流水号：{{ idnum }}
      </p>
      <p style="
          font-size: 20px;
          color: green;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        ">
        结果：{{ ResultRetData }}
      </p>
      <div style="margin: 16px">
        <van-button type="primary" size="large" @click="fromSecondSubmit()">查询</van-button>
        <van-button type="primary" size="large" @click="fromClearSubmit()">重置</van-button>
        <van-button type="primary" size="large" @click="BaseSubmit()">requestFacePhoto</van-button>
        <p style="
          font-size: 20px;
          color: green;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        ">
          base64:{{ ResultBase }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { Field, Button, Form, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      certName: "",
      certNo: "",
      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
      topicName: "测试",
      ResultRetData: "",
      ResultcertName: "",
      ResultCertNo: "",
      idnum: "",
      Resultidnum: "",
      disabled: false,
      ResultBase: "",
    };
    //console.log(this);
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
    window.resultSilentFace = this.resultSilentFace;
    window.resultFacePhoto = this.resultFacePhoto;
  },

  methods: {
    //首次提交
    fromSubmit() {
      console.log(this);
      if (this.certNo != "" && this.certName != "") {
        var today = new Date();
        var month = today.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        var day =
          today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
        var hours =
          today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
        var mins =
          today.getMinutes() < 10
            ? "0" + today.getMinutes()
            : today.getMinutes();
        var secs =
          today.getSeconds() < 10
            ? "0" + today.getSeconds()
            : today.getSeconds();

        //四位随机数
        var randnum = Math.floor(Math.random() * (9999 - 1000)) + 1000;
        var now1 =
          today.getFullYear() + month + +day + hours + mins + secs + randnum;
        this.disabled = true;
      }
      /**
       * certName  用户姓名
       * certNo    用户身份证号
       * idNumber  业务流水号
       */
      let keys = {
        certName: this.certName,
        certNo: this.certNo,
        idNumber: now1,
      };

      console.log(keys);
      this.idnum = now1;
      this.ResultcertName = this.certName;
      this.ResultCertNo = this.certNo;
      this.$tool.callModule("requestSilentFace", JSON.stringify(keys));
    },
    //调用人脸识别接口=>回调resultFacePhoto(base64字符串)
    BaseSubmit() {
      this.$tool.callModule("requestFacePhoto");
      console.log("requestFacePhoto");
    },
    resultFacePhoto(base) {
      console.log(base);
      this.ResultBase = base;
    },
    resultSilentFace(val) {
      var neval = JSON.parse(val);
      this.ResultRetData = val;
      this.Resultidnum = `${neval.retData.authSn}`;
      console.log(val);
      console.log(neval);
    },
    /**
     * querySilentFaceResult 再次查询按钮方法
     * keys 当前流水号
     */
    fromSecondSubmit() {
      if (this.idnum != "") {
        let keys = {
          idNumber: this.Resultidnum,
        };
        console.log(keys);
        this.$tool.callModule("querySilentFaceResult", JSON.stringify(keys));
      }
    },
    fromClearSubmit() {
      console.log(this);
      this.$options.data(); // 重置数据
      Object.assign(this.$data, this.$options.data());
    },
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
};
</script>

<style>
</style>